import React from "react";
import { CheckSquare, Clock, AlertTriangle, AlertCircle, RefreshCw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useWhatsAppTask } from "../../../../client/hooks/useWhatsAppData";

export default function WhatsTaskCard({ taskId, isReceived, onClick }) {
  const { t } = useTranslation("tasks");

  const { data, isLoading, isError } = useWhatsAppTask(taskId);

  if (isLoading) {
    return (
      <div style={{ padding: "10px", backgroundColor: "rgba(0,0,0,0.05)", borderRadius: "8px", marginTop: "4px" }}>
        <RefreshCw size={14} className="spin-animation" style={{ marginRight: "6px" }} />
        <span style={{ fontSize: "12px", color: "#666" }}>Cargando tarea...</span>
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div style={{ padding: "10px", backgroundColor: "#fee2e2", borderRadius: "8px", marginTop: "4px" }}>
        <span style={{ fontSize: "12px", color: "#ef4444" }}>Error cargando tarea {taskId.slice(0, 8)}...</span>
      </div>
    );
  }

  let bgColor = "#f3f4f6"; // Gray (Pendiente)
  let borderColor = "#e5e7eb";
  let icon = <Clock size={16} color="#4b5563" />;
  let statusText = "Pendiente";

  if (data.checked || data.stage === "done") {
    bgColor = "#dcfce7"; // Green (Terminada)
    borderColor = "#bbf7d0";
    icon = <CheckSquare size={16} color="#16a34a" />;
    statusText = "Terminada";
  } else if (data.stage === "review") {
    bgColor = "#fef9c3"; // Yellow (En revisión)
    borderColor = "#fef08a";
    icon = <AlertTriangle size={16} color="#ca8a04" />;
    statusText = "En revisión";
  } else if (data.stage === "blocked") {
    bgColor = "#fee2e2"; // Red (Bloqueada)
    borderColor = "#fecaca";
    icon = <AlertCircle size={16} color="#dc2626" />;
    statusText = "Bloqueada";
  } else if (data.stage === "doing") {
    bgColor = "#e0f2fe"; // Blue (En progreso)
    borderColor = "#bae6fd";
    icon = <RefreshCw size={16} color="#0284c7" />;
    statusText = "En progreso";
  }

  return (
    <div
      onClick={() => onClick && onClick(data)}
      style={{
        marginTop: "6px",
        padding: "10px 12px",
        backgroundColor: bgColor,
        border: `1px solid ${borderColor}`,
        borderRadius: "8px",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        minWidth: "200px"
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "6px", fontWeight: "600", fontSize: "12px", color: "#374151" }}>
          {icon}
          {statusText}
        </div>
        <div style={{ fontSize: "10px", color: "#6b7280" }}>
          {(() => {
            const targetDate = data.end_time || data.date || data.start_time;
            if (!targetDate) return '';
            const now = new Date();
            const target = new Date(targetDate);
            now.setHours(0,0,0,0);
            target.setHours(0,0,0,0);
            const diffTime = target - now;
            const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
            
            if (diffDays === 0) return 'Hoy';
            if (diffDays === 1) return 'Mañana';
            if (diffDays === -1) return 'Ayer';
            if (diffDays > 1) return `Faltan ${diffDays} días`;
            return `Pasaron ${Math.abs(diffDays)} días`;
          })()}
        </div>
      </div>
      <div style={{ fontSize: "14px", fontWeight: "600", color: "#111827", lineHeight: "1.2" }}>
        {data.title}
      </div>
      {data.assignee && (
        <div style={{ fontSize: "11px", color: "#4b5563" }}>
          Asignado a: <span style={{ fontWeight: "500" }}>{data.assignee}</span>
        </div>
      )}
    </div>
  );
}
